<template lang="pug">
  section#home
    .section__content
      //- .caption
      //-   h1.caption__text.text-hide 職涯格局緊來造
      //- .description
      //-   p.description__text #[span 好的職涯格局要創造]
      //-   p.description__text #[span 讓視網膜為你進行職涯分析]
      ul.buttons
        li
          a.button(href="#" @click.prevent="startQuiz" ref="button") #[span 立即分析]
      //- .characters
      //-   .character
      //-   .character
      //-   .character
      //- audio#bgm(loop ref="bgm")
      //-   source(src='/audio/music.mp3' type='audio/mpeg')
      //- p iOS 版本 {{ iosVersion }}
      a#start_campagin.enter(href="#" @click.prevent="startQuiz")
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Home',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['player', 'iosVersion'])
  },
  methods: {
    ...mapMutations(['setPage', 'setIosVersion']),
    startQuiz() {
      // const { audioPlayer } = this;
      this.setPage('Quiz');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
      this.$trackEvent('index_start', 'click', 'index_start');
      this.player.playVideo();
      if (this.iosVersion <= 14) {
        // audioPlayer.play();
      }
    },
    checkVersion() {
      const agent = window.navigator.userAgent,
      start = agent.indexOf('OS ');
      if ((agent.indexOf('iPhone') > -1 || agent.indexOf('iPad') > -1) && start > -1) {
        return window.Number(agent.substr(start + 3, 3).replace('_', '.'));
      }
      return 0;
    }
  },
  mounted() {
    this.setIosVersion(this.checkVersion());
    // const { bgm } = this.$refs;
    // this.setAudioPlayer(bgm);
    // this.audioPlayer.volume = 0.1;
    // this.version = this.checkVersion();
    // bgm.addEventListener('canplaythrough', () => {
    //   bgm.play();
    //   bgm.volume = 0.1;
    //   // if (bgm.muted && !this.bgmInited) {
    //   //   this.toggleBgm();
    //   // }
    //   // this.bgmInited = true;
    // });
    // bgm.addEventListener('timeupdate', function(){
    //     var buffer = .32
    //     if(this.currentTime > this.duration - buffer){
    //         this.currentTime = 0
    //         this.play()
    //     }
    // });
    const { button } = this.$refs;
    setInterval(() => {
      button.classList.toggle('on')
    }, 750)
  },
  components: {
  }
}
</script>

<style lang="scss">

$assets: '~@/assets/images/home/';

#home {

  position: relative;
  z-index: 3;
  
  display: flex;
  align-items: center;
  justify-content: center;

  // background-image: url($assets + 'background_desktop.jpg');
  background-position: center top;
  background-repeat: no-repeat;
  background-size: vwXL(1920) vwXL(1080);

  @include tablet {

    height: calc(var(--vh, 1vh) * 100);
    background-image: url($assets + 'background_v2.jpg');
    background-position: center top;
    background-size: vw(750) vw(1836);
  }

  .enter {
    display: none;
    @include tablet {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      // background: red;
      z-index: 1;
    }
  }

  .section__content {
    position: relative;
    flex-basis: 100%;
    // height: 100%;
    background-repeat: no-repeat;
    overflow: hidden;

    // min-height: 1334px;
    height: calc(var(--vh, 1vh) * 100);
    background: url($assets + 'background_desktop_v2.jpg') center center no-repeat;
    background-size: cover;

    box-shadow: rgba(#007f38, 1) inset 0 0 0 vhX(18);

    @include tablet {
      min-height: vw(1300);
      background: url($assets + 'background_v3.jpg') #007f38 center top no-repeat;
      background-size: vw(750) auto;
    }
  }

  // 標題
  .caption {

    position: absolute;
    background-color: #07aa6d;
    background-position: 0 0;
    background-repeat: repeat;
    overflow: hidden;

    top: vwXL(28);
    left: 50%;
    width: vwXL(621);
    height: vwXL(325);
    background-image: url($assets + 'caption-background.png');
    background-position: vwXL(4) vwXL(13);
    background-size: vwXL(39) vwXL(40);
    animation: homeCaptionBg 3s linear infinite forwards;
    transform: translateX(vwXL(-385));

    --homeCaptionX: #{vwXL(390)};
    --homeCaptionY: #{vwXL(400)};

    @include tablet {
      top: vw(78);
      left: 0;
      width: vw(477);
      height: vw(282);
      background-image: url($assets + 'caption-background.png');
      background-position: vw(4) vw(13);
      background-size: vw(33) vw(30);
      transform: none;
      --homeCaptionX: #{vw(330)};
      --homeCaptionY: #{vw(300)};
    }

    @keyframes homeCaptionBg {
      0% {
        background-position: 0 0;
      }
      100% {
        background-position: var(--homeCaptionX) var(--homeCaptionY);
      }
    }

    &__text {

      position: absolute;
      background-position: 0 0;
      background-repeat: no-repeat;

      top: vwXL(48);
      left: vwXL(67);
      width: vwXL(562);
      height: vwXL(285);
      background-image: url($assets + 'caption_desktop.png');
      background-size: contain;
      animation: homeCaptionText 2s ease-in-out infinite forwards;

      @include tablet {
        top: vw(40);
        left: vw(52);
        width: vw(574);
        height: vw(264);
        background-image: url($assets + 'caption.png');
        // background-size: contain;
        // animation: homeCaptionText 2s ease-in-out infinite forwards;
      }

    }

    @keyframes homeCaptionText {
      0% {
        transform: translate(0, 0);
      }
      50% {
        transform: translate(2%, 11%);
      }
      100% {
        transform: translate(0, 0);
      }
    }

  }

  // 描述文字
  .description {
    position: absolute;
    top: vwXL(492);
    left: 50%;
    color: #fff;
    font-size: vwXL(28);
    line-height: lineHeight(36, 53.75);
    letter-spacing: vwXL(PsdLetterSpacing(20, 36));
    @include stroke(#009944, vwXL(3));
    transform: translateX(vwXL(-212));
    @include tablet {
      top: vw(722);
      left: vw(288);
      font-size: vw(32);
      line-height: lineHeight(32, 53.75);
      letter-spacing: vw(PsdLetterSpacing(160, 32));
      @include stroke(#009944, vw(4));
      transform: none;
    }
    span {
      @include narrow-text;
    }
  }

  // 按鈕群
  .buttons {

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(vhX(-497), vhX(54));

    @include tablet {
      top: vw(593);
      left: vw(50);
      transform: none;
      z-index: 1;
    }

    // li {
    //   @include tablet {
    //     position: relative;
    //     &::after {
    //       content: '';
    //       position: absolute;
    //       top: vw(131);
    //       left: vw(-6);
    //       width: vw(135);
    //       height: vw(160);
    //       background-image: url($assets + 'hand.png');
    //       background-position: 0 0;
    //       background-repeat: no-repeat;
    //       background-size: contain;
    //       pointer-events: none;
    //       animation: handMove 1.5s ease-in-out 0s infinite;
    //     }
    //   }
    // }

    // @keyframes handMove {
    //   0%, 100% {
    //     transform: translate(-15%, 20%);
    //   }
    //   50% {
    //     transform: translate(0%, 0%);
    //   }
    // }

    .button {
      width: vhX(476);
      height: vhX(240);
      font-size: 0;
      // font-size: vwXL(44);
      // text-indent: vwXL(PsdLetterSpacing(420, 44));
      // letter-spacing: vwXL(PsdLetterSpacing(420, 44));
      background-image: url($assets + 'button_desktop_v3.png');
      background-size: vhX(476) vhX(480);
      // @include blink-button(vwXL(-90));

      @include tablet {
        width: vw(403);
        height: vw(200);
        // text-indent: vw(PsdLetterSpacing(420, 90));
        // letter-spacing: vw(PsdLetterSpacing(420, 90));
        background-image: url($assets + 'button_v3.png');
        background-size: vw(403) vw(400);
        // @include blink-button(vw(-200));
        pointer-events: none;
      }

      span {
        @include narrow-text;
        transform-origin: center center;
        pointer-events: none;
      }
    }

    .button.on {
      background-position: 0 vhX(-240);
      @include tablet {
        background-position: 0 vw(-200);
      }
    }

  }

  // 人物
  .characters {

    .character {
      position: absolute;
      // top: 50%;
      pointer-events: none;
      // @include tablet {
      //   top: 50%;
      // }
      &::before,
      &::after {
        content: '';
        position: absolute;
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: contain;
      }
    }

    // 視網膜 1
    .character:nth-child(1) {
      top: vwXL(38);
      right: 50%;
      width: vwXL(637);
      height: vwXL(1042);
      transform: translateX(vwXL(619));
      @include tablet {
        top: vw(22);
        right: 0;
        width: vw(586);
        height: vw(686);
        transform: none;
      }
      // 陰影
      &::before {
        content: none;
        // @include tablet {
        //   top: vw(6);
        //   width: 100%;
        //   height: 100%;
        //   background-image: url($assets + 'character-1-shadow.png');
        // }
      }
      // 本體
      &::after {
        // top: 6px;
        width: 100%;
        height: 100%;
        // filter: drop-shadow(16px 0px 2px rgba(25,115,120,0.7));
        background-image: url($assets + 'character-1-body_desktop.png');
        @include tablet {
          top: vw(6);
          // width: 100%;
          // height: 100%;
          // filter: drop-shadow(vw(16) vw(0) vw(2) rgba(25,115,120,0.7));
          background-image: url($assets + 'character-1-body_v2.png');
        }
      }
    }

    // 視網膜 2
    .character:nth-child(2) {
      top: vwXL(13);
      left: 50%;
      width: vwXL(234);
      height: vwXL(320);
      transform: translateX(vwXL(-567));
      @include tablet {
        top: vw(349);
        left: 0;
        width: vw(307);
        height: vw(664);
        transform: none;
      }
      // 陰影
      &::before {
        content: none;
        // @include tablet {
        //   top: vw(6);
        //   width: 100%;
        //   height: 100%;
        //   background-image: url($assets + 'character-1-shadow.png');
        // }
      }
      // 本體
      &::after {
        width: 100%;
        height: 100%;
        // filter: drop-shadow(16px 0px 2px rgba(37,145,129,0.9));
        background-image: url($assets + 'character-2-body_desktop.png');
        @include tablet {
          // width: 100%;
          // height: 100%;
          // filter: drop-shadow(vw(16) vw(0) vw(2) rgba(37,145,129,0.9));
          background-image: url($assets + 'character-2-body_v2.png');
        }
      }
    }

    // 柚子
    .character:nth-child(3) {
      // background-repeat: no-repeat;
      top: vwXL(387);
      left: 50%;
      width: vwXL(266);
      height: vwXL(331);
      // background-image: url($assets + 'character-3-background.png');
      // background-position: 18px 61px;
      background-size: contain;
      overflow: hidden;
      transform: translateX(vwXL(-523));
      @include tablet {
        top: vw(994);
        right: 0;
        left: auto;
        width: vw(465);
        height: vw(323);
        // background-image: url($assets + 'character-3-background.png');
        // background-position: vw(18) vw(61);
        // background-size: vw(375) vw(406);
        // overflow: hidden;
        transform: none;
        z-index: 1;
      }
      // 柚子本體
      &::before {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url($assets + 'character-3-body_desktop.png');
        @include tablet {
          // top: 0;
          // left: vw(108);
          // width: vw(195);
          // height: vw(448);
          background-image: url($assets + 'character-3-body_v2.png');
        }
      }
      // 柚子手手
      // &::after {
      //   top: 176px;
      //   left: 81px;
      //   width: 84px;
      //   height: 151px;
      //   background-image: url($assets + 'character-3-hand.png');
      //   animation: homeDogHand 1s linear infinite forwards;
      //   transform-origin: 54px 100px;
      //   @include tablet {
      //     top: vw(176);
      //     left: vw(81);
      //     width: vw(84);
      //     height: vw(151);
      //     // background-image: url($assets + 'character-3-hand.png');
      //     // animation: homeDogHand 1s linear infinite forwards;
      //     transform-origin: vw(54) vw(100);
      //   }
      //   @keyframes homeDogHand {
      //     0% {
      //       transform: rotate(0deg);
      //     }
      //     49.5% {
      //       transform: rotate(0deg);
      //     }
      //     50% {
      //       transform: rotate(5deg);
      //     }
      //     100% {
      //       transform: rotate(5deg);
      //     }
      //   }
      // }
    }

    // 視網膜 3
    // .character:nth-child(4) {
    //   @include tablet {
    //     left: 50%;
    //     width: vw(350);
    //     height: vw(310);
    //     transform: translate(vw(-227), vw(590));
    //   }
    //   // 陰影
    //   &::before {
    //     content: none;
    //     // @include tablet {
    //     //   top: vw(6);
    //     //   width: 100%;
    //     //   height: 100%;
    //     //   background-image: url($assets + 'character-1-shadow.png');
    //     // }
    //   }
    //   // 本體
    //   &::after {
    //     @include tablet {
    //       width: 100%;
    //       height: 100%;
    //       filter: drop-shadow(vw(16) vw(2) vw(2) rgba(0,0,0,0.7));
    //       background-image: url($assets + 'character-4-body.png');
    //     }
    //   }
    // }

  }

  .section__content::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url($assets + 'main_desktop.png');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 100%;
    @include tablet {
      content: none
    }
  }

  // 額外物件
  .section__content::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    background-color: #07aa6d;

    width: 336px;
    height: 302px;
    transform: translateY(557px);
    background-image: url($assets + 'extra-background.png');
    background-position: 10px 12px;
    background-size: 27px 24px;
    mask: url($assets + 'extra-mask.png');
    mask-size: contain;
    animation: homeExtraBg 3s linear infinite forwards;
    --homeExtraX: 270px;
    --homeExtraY: -240px;
    display: none;
    @include tablet {
      width: vw(336);
      height: vw(302);
      transform: translateY(vw(557));
      // background-image: url($assets + 'extra-background.png');
      background-position: vw(10) vw(12);
      background-size: vw(27) vw(24);
      // mask: url($assets + 'extra-mask.png');
      // mask-size: contain;
      // animation: homeExtraBg 3s linear infinite forwards;
      --homeExtraX: #{vw(270)};
      --homeExtraY: #{vw(-240)};
    }
    @keyframes homeExtraBg {
      0% {
        background-position: 0 0;
      }
      100% {
        background-position: var(--homeExtraX) var(--homeExtraY);
      }
    }
  }

  #bgm {
    position: fixed;
    top: 0;
    left: 0;
    display: none;
  }

}

</style>
